import { USER_REQUEST, USER_ERROR, USER_SUCCESS, GET_USERS, GET_ROLE, ROLE_SUCCESS} from '../actions/user'

import Vue from 'vue'
import graphqlClient from '../gqlclient';
import { AUTH_LOGOUT } from '../actions/auth'
import _ from "lodash";
const state = { status: '', profile: {}}
const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,

  getRole: state => state.role
}

const actions = {
  [USER_REQUEST]: ({commit, dispatch}) => {
    console.log('get user')
    return new Promise((resolve, reject) => {
    commit(USER_REQUEST)
    const token = window.localStorage.getItem('jwt_token')
    graphqlClient.query({query:require('../../components/Login/profile.gql'),fetchPolicy:'no-cache',headers:{authorisation:`Bearer ${token}`}})
      .then(resp => {
        if(resp.errors){
          reject(resp)
        }
        commit(USER_SUCCESS, resp.data)  
        resolve(resp)
      })
    
    })
  },
  [GET_ROLE]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
    commit(GET_ROLE)
    console.log('get role')
        const token = localStorage.getItem('vuex')
        const role = token.auth.role
        console.log('Role is ',role)
        commit(ROLE_SUCCESS,role)
        resolve(resp);

    })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [GET_USERS]: (state) => {
    state.status = 'loading'
  },
  [GET_ROLE]: (state) => {
    state.status = 'loading'

  },
  [USER_SUCCESS]: (state, resp) => {
    console.log('save profile',resp)
    state.status = 'success'
    //super user gets all partners
    if (resp.partner.length>1){
      let a = resp.partner.filter(p =>{return p.name==='tefl'})[0]
      state.profile.logo=a.logo
      state.profile.name=a.name
      state.profile.colours=a.colours

    }else{
    state.profile.logo=resp.partner[0].logo_url
    state.profile.name=resp.partner[0].name
    state.profile.colours=resp.partner[0].colours
    }
   // Vue.set(state, 'profile', resp)
  },
  [ROLE_SUCCESS]: (state, resp) => {
    state.status = 'success'

    Vue.set(state, 'role', resp)

   //fake a role
  //  Vue.set(state, 'role', 'tutor')

  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js